import React from "react";
import "./lastDep.css";
import aba from "../../asset/aba.png";

const LastDep = () => {
  return (
    <>
      <div className="lastDepPage">
        {" "}
        <div className="lastDeposits">
          <h3>Last Deposits</h3>
          <table>
            <thead>
              <tr>
                <th>Payment</th>
                <th>User</th>
                <th>Timedate</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Cassy240</td>
                <td>Sep-4-2024 11:49:21 PM</td>
                <td>$240,000.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Cassy240</td>
                <td>Sep-4-2024 11:13:38 PM</td>
                <td>$10,000.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Sambull</td>
                <td>Aug-31-2024 08:18:06 PM</td>
                <td>$10,000.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>wantu2</td>
                <td>Aug-1-2024 08:42:51 PM</td>
                <td>$1,000.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>jamesringer</td>
                <td>Jul-6-2024 01:08:00 PM</td>
                <td>$50,000.00</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="lastWithdrawals">
          <h3>Last Withdrawals</h3>
          <table>
            <thead>
              <tr>
                <th>Payment</th>
                <th>User</th>
                <th>Timedate</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Alvita</td>
                <td>Sep-4-2024 11:49:21 PM</td>
                <td>$1,200.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Smbull</td>
                <td>Sep-4-2024 11:13:38 PM</td>
                <td>$14,500.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Johndo</td>
                <td>Aug-31-2024 08:18:06 PM</td>
                <td>$3,600.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Ryan</td>
                <td>Aug-1-2024 08:42:51 PM</td>
                <td>$6,000.00</td>
              </tr>
              <tr>
                <td class="center">
                  <img src={aba} alt="" />
                </td>
                <td>Travis</td>
                <td>Jul-6-2024 01:08:00 PM</td>
                <td>$7,000.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default LastDep;
